module.exports = __webpack_public_path__ + "static/media/9-redcube.1e73ed88.png";